<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="task.client"
          (selectedClientChange)="selectedClient()"
          [showClear]="true"
          [customSearch]="false"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Дата проезда</label>
        <crm-datepicker
          [(value)]="task.date"
          [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
          appendTo="body"></crm-datepicker>
        <small
          *ngIf="errors?.date"
          class="p-error">
          {{ errors?.date | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Гос. номер ТС</label>
        <crm-input-text
          [(value)]="task.carNumber"
          [isError]="$any(errors?.carNumber)"></crm-input-text>
        <small
          *ngIf="errors?.carNumber"
          class="p-error">
          {{ errors.carNumber | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Категория ТС</label>
        <crm-car-category-single-select
          [isError]="$any(errors?.category)"
          [(selectedCategory)]="task.category"
          appendTo="body">
        </crm-car-category-single-select>
        <small
          *ngIf="errors?.category"
          class="p-error">
          {{ errors.category | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Помещения</label>
        <crm-room-multi-select
          [isError]="$any(errors?.rooms)"
          [(selectedRooms)]="task.rooms"
          [isFloatLabel]="false"
          [onlyWithHikvisionCameras]="true"
          [autoSelectOne]="true"
          appendTo="body">
        </crm-room-multi-select>
        <small
          *ngIf="errors?.rooms"
          class="p-error">
          {{ errors.rooms | join }}
        </small>
      </div>
    </div>
  </p-card>

  <p-card
    header="Участники"
    styleClass="mt-3">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium">Ответственный</label>
        <crm-user-single-select
          [users]="users"
          [(selectedUser)]="task.responsible"
          [customSearch]="true"
          [isError]="$any(errors?.responsible)"
          appendTo="body"></crm-user-single-select>
        <small
          *ngIf="errors?.responsible"
          class="p-error">
          {{ errors.responsible | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Внешний пользователь</label>
        <div class="flex align-items-center gap-1">
          <div class="flex-grow-1">
            <crm-external-user-single-select
              #externalUserSingleSelectComponent
              [(selectedExternalUser)]="task.externalUser"
              [clientId]="task.client?.id"
              [isError]="$any(errors?.externalUser)"
              [disabled]="!task.client?.contragents?.length"
              appendTo="body"></crm-external-user-single-select>
          </div>
          <p-button
            *ngIf="task.client?.id && task.client?.contragents?.length"
            icon="pi pi-plus"
            (click)="openFormCreateExternalUser()"></p-button>
        </div>
        <small
          *ngIf="errors?.externalUser"
          class="p-error">
          {{ errors.externalUser | join }}
        </small>
      </div>

      <h3 class="font-medium -mb-2">Аудиторы</h3>
      <p-divider></p-divider>
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [users]="users"
            [(selectedUsers)]="task.userAuditors"
            [customRequest]="true"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
        </div>

        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-multi-select
            [(selectedItems)]="task.userGroupAuditors"
            [options]="userGroups"
            appendTo="body">
          </crm-multi-select>
        </div>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveTask()"></button>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteTask()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
